import { List } from 'immutable';
import is from 'is_js';
import { actions as GroupMembers } from 'data/GroupMembers';
import { getUnitNumberById, getUnitList } from 'data/Units/accessors';
import { isFutureSession, getNextSession } from 'data/SessionPlans/accessors';

export function getCurrentPaperBasedHomework(state, sessionPlanId) {
  const currentPaperBasedHomework = state.get('rootReducer').get('paperBasedHomework')
        .get(sessionPlanId);
  return currentPaperBasedHomework;
}

export function isMarkable(state, groupId, sessionPlanId) {
  const currentPaperBasedHomework = getCurrentPaperBasedHomework(state, sessionPlanId);
  const nextSession = getNextSession(state, groupId, sessionPlanId);
  const isFutrueSession = isFutureSession(state, sessionPlanId);
  const isFutureNextSession = isFutureSession(state, nextSession.id);
  return ! isFutrueSession &&
    ! isFutureNextSession &&
    currentPaperBasedHomework &&
    List.isList(currentPaperBasedHomework) &&
    currentPaperBasedHomework.size > 0 &&
    currentPaperBasedHomework.some((homework) => homework.studentPaperBasedHomeworks.size > 0);
}

export function getHomeworkStudentList(state, sessionPlan, groupId) {
  const groupMembers = GroupMembers.getMembersByGroup(state, groupId);
  const { id: sessionPlanId } = sessionPlan;
  let currentSessionHomeworks = state.get('rootReducer').get('paperBasedHomework').get(sessionPlanId);
  const units = getUnitList(state, groupId);
  if (!! currentSessionHomeworks && !! units) {
    currentSessionHomeworks = currentSessionHomeworks.map((lessonHomework) =>
        lessonHomework.set('unitOrderingSequence', getUnitNumberById(units, `${lessonHomework.unitId}`)));

    currentSessionHomeworks = currentSessionHomeworks.map((lessonHomework) =>
        lessonHomework.update('studentPaperBasedHomeworks', (studentPaperBaseds) =>
          studentPaperBaseds.map((student) => {
            const studentId = student.studentId;
            const groupMember = groupMembers.find((member) =>
              member.studentGeneralInfo.id === studentId);
            if (is.undefined(groupMember)) {
              return student;
            }
            return student.set('isInProduction', groupMember.isInProduction)
              .set('studentStatus', groupMember.status)
              .set('studentGeneralInfo', groupMember.studentGeneralInfo);
          })));

    currentSessionHomeworks = currentSessionHomeworks.map((lessonHomework) =>
        lessonHomework.update('studentTutorialHomeworks', (studentTutorials) =>
          studentTutorials.map((student) => {
            const studentId = student.studentId;
            const groupMember = groupMembers.find((member) =>
              member.studentGeneralInfo.id === studentId);
            if (is.undefined(groupMember)) {
              return student;
            }
            return student.set('isInProduction', groupMember.isInProduction)
              .set('studentStatus', groupMember.status)
              .set('studentGeneralInfo', groupMember.studentGeneralInfo);
          })));
  }
  return currentSessionHomeworks;
}




// WEBPACK FOOTER //
// ./data/PaperBasedHomework/accessors.js